import { combineReducers } from 'redux';
import context from './context';
import dialog from './dialog';
import dashboard from './dashboard';
import debitSignUp from './debitSignUp';
import deposit from './deposit';
import investments from './investments';
import search from './search';
import nav from './nav';
import reactivation from './reactivation';
import signUp from './signUp';
import toast from './toast';
import linkBank from './linkBank';
import drawer from './drawer';
import deferredActions from './deferredActions';
import refreshTokenPending from './refreshTokenPending';
import modal from './modal';
import productEvents from './productEvents';
import idempotencyKey from './idempotencyKey';
import retire from './retire';
import accountFunding from './accountFunding';
import autoStashUpdate from './autoStashUpdate';
import downgrade from './downgrade';
import portfolioConversion from './portfolioConversion';

export default combineReducers({
	accountFunding,
	autoStashUpdate,
	context,
	dashboard,
	debitSignUp,
	downgrade,
	drawer,
	deposit,
	dialog,
	investments,
	linkBank,
	nav,
	portfolioConversion,
	reactivation,
	refreshTokenPending,
	search,
	signUp,
	toast,
	deferredActions,
	modal,
	productEvents,
	idempotencyKey,
	retire,
});
